<template>
  <MarkDown v-model="val" :label="label || title"></MarkDown>
</template>

<script>
import MarkDown from "@/components/MarkDown"
export default {
  components: {
    MarkDown
  },
	props: [
		'name',
		'value',
		'label',
    'title'
	],
	computed: {
    val: {
      get () {
        return _.get(this.value, this.name);
      },
      set (val) {
        var value = _.cloneDeep(this.value);
        _.set(value, this.name, val);
        this.$emit("input", value);
      }
    }
  }
}
</script>
